export const dateRangesAreEqual = (
    dateRangeA: MaybeEmptyDateRange,
    dateRangeB: MaybeEmptyDateRange,
): boolean => {
    if (dateRangeA.end === null && dateRangeB.end === null) {
        return true;
    }

    if (dateRangeA.end !== null && dateRangeB.end !== null) {
        if (
            dateRangeA.end.getTime() === dateRangeB.end.getTime() &&
            dateRangeA.start.getTime() === dateRangeB.start.getTime()
        ) {
            return true;
        }
    }

    return false;
};
